import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import reportWebVitals from "./reportWebVitals";
import { ToastProvider } from "./Services/ToastContext";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import "./i18n";
import { AppConfig } from "./api/config/config";
import { HelmetProvider } from "react-helmet-async";

const defaultOptions = {
  queries: {
    staleTime: 60 * 60 * 1000, // refetch after 60 min
    cacheTime: 5 * 60 * 1000, // cache for 10 min
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  },
};

const queryClient = new QueryClient({
  defaultOptions,
});

async function startApp() {
  await AppConfig.load();
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  root.render(
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ToastProvider>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </ToastProvider>
      </Provider>
    </QueryClientProvider>,
  );

  reportWebVitals();
}

startApp();